<div class="fill-process">
    <div (click)="isToggle = !isToggle" [collapse]="!isToggle" class="head">
        Process
        <i class="fa fa-caret-down"></i>
    </div>
    <div [collapse]="isToggle">
        <h5>
            Enter the name of the process
            <i (click)="isToggle = !isToggle" class="fa fa-caret-up"></i>
        </h5>
        <form [formGroup]="processGeneralInfoForm">
        <div class="en-translation">
            <input *ngFor="let item of namePropertyArray; let i=index;" 
            [placeholder]="placeholderArray[i]" 
            [formControlName]="item"  type="text"/>
        </div>
        <div class="en-translation">
            <textarea maxlength="500" *ngFor="let item of descriptions; let i=index;" 
            [placeholder]="descriptionPlaceholders[i]" 
            [formControlName]="item"></textarea>           
        </div>
        <div class="m-t-10">
            <div class="caption m-b-5" id="survey_list">
                Survey
            </div>
            <div class="input-select" *ngIf="surveys">
                <ngx-select [items]="surveyItems" [formControl]="surveySelectControl" placeholder="Enter a name for the search or select from the list"></ngx-select>
            </div>
        </div>
        <div class="terms">
            <div class="caption">
                Launch date:<br />
                <input class="m-t-5" 
                #launchDate="bsDatepicker"
                [minDate]="minDate"
                formControlName="startDate" 
                bsDatepicker>
                <i (click)="launchDate.toggle()" class="fa fa-calendar"></i>
            </div>
            <div class="caption">
                Expiration date:<br />
                <input class="m-t-5"
                #expirationDate="bsDatepicker"
                [minDate]="minDate"
                formControlName="endDate" 
                bsDatepicker />
                <i (click)="expirationDate.toggle()" class="fa fa-calendar"></i>
            </div>
        </div>
    </form>
    </div>
</div>



